import { ActionId } from 'owa-mail-list-item-animation-store';
import {
    TableView,
    MailFolderTableQuery,
    isConversationView,
    getTableConversationRelation,
} from 'owa-mail-list-store';
import {
    isDeletedItemsFolderFromAnyMailbox,
    isUnderDeletedItemsFolderFromAnyMailbox,
} from 'owa-mail-store';
import folderStore from 'owa-folders';
import isArchiveFolder from 'owa-mail-folder-store/lib/utils/isArchiveFolder';

export function canAnimateRows(
    tableView: TableView,
    animationRowIds: string[],
    animationAction: ActionId
) {
    const scenario = (tableView.tableQuery as MailFolderTableQuery).scenarioType;
    let canItemsAnimate: boolean = true;

    if (animationAction === 'Archive' && isArchiveFolder(tableView.tableQuery.folderId)) {
        return false;
    }

    if (scenario !== 'mail' && scenario !== 'group') {
        if (animationAction === 'Archive' || animationAction === 'Move') {
            return false;
        }
        if (isConversationView(tableView)) {
            const folderIds = animationRowIds.map(
                animationRowId =>
                    getTableConversationRelation(animationRowId, tableView.id)?.parentFolderId
            );

            canItemsAnimate = folderIds.every(folderId => {
                if (folderId) {
                    const sourceFolder = folderStore.folderTable.get(folderId);
                    return (
                        isDeletedItemsFolderFromAnyMailbox(folderId) ||
                        // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
                        // -> Error TS2345 (172,53): Argument of type 'MailFolder | undefined' is not assignable to parameter of type 'MailFolder'.
                        // @ts-ignore
                        isUnderDeletedItemsFolderFromAnyMailbox(sourceFolder)
                    );
                }
                return false;
            });
        }
    }

    return canItemsAnimate;
}
